import React from 'react';
import { SubHeaderRails } from '../../../components/sub-header/SubHeaderRails';
import { LawFirmActionSlider } from './LawFirmActionSlider';
import { MobileBar } from '../../../components/mobile-bar/MobileBar';
import { LawFirmInfos } from '../../lawFirm.types';

type Props = {
  isVisible: boolean;
  lawFirmInfos: LawFirmInfos;
};

export const LawFirmMobileBar = ({
  isVisible,
  lawFirmInfos: { name, lawOfficeIdGroup },
}: Props) => (
  <MobileBar>
    <SubHeaderRails>
      <LawFirmActionSlider
        isVisible={isVisible}
        name={name}
        lawOfficeIdGroup={lawOfficeIdGroup}
      />
    </SubHeaderRails>
  </MobileBar>
);
